import React from 'react';
export const Subheading = ({ field }) => {
    return (React.createElement("div", { className: "zds-margin-top-6 zds-padding-bottom-2 powermail-subheading " },
        React.createElement("h5", { className: "zds-headline-sm" }, field.title)));
};
